<template>
    <section>
        <div v-if="!single" class="is-relative">
            <h3 class="stepper__content__header">{{ $t('RISK_FACTORS') }}</h3>
        </div>

        <steps v-if="!single" :activeStep="2" :steps="10" class="text-xs-center mb-4"></steps>

        <div class="content__wrapper flex-center">
            <h4 class="stepper__content__title">
                {{ $t('ZGRUBIENIE_GUZEK') }}
            </h4>

            <div class="mb-3">
                <h5 class="mb-3">{{ $t('RIGHT_BREAST') }}</h5>

                <div class="flex-row">
                    <label class="fake-label">
                        <input
                            class="custom-input"
                            type="radio"
                            value="YES"
                            name="right-breast"
                            @click="rightBreastSection(true)"
                            v-model="s3q2Val"
                        />
                        <span class="input-container">{{ $t('YES') }}</span>
                        <span class="checkmark"></span>
                    </label>
                    <label class="fake-label">
                        <input
                            class="custom-input"
                            type="radio"
                            value="NO"
                            name="right-breast"
                            @click="rightBreastSection(false)"
                            v-model="s3q2Val"
                        />
                        <span class="input-container">{{ $t('NO') }}</span>
                        <span class="checkmark"></span>
                    </label>
                </div>

                <right-breast-changes
                    class="mt-3"
                    v-if="showRightBreastSection"
                    @clicked="rightSelect"
                ></right-breast-changes>
            </div>

            <div class="mb-3">
                <h5 class="mb-3">{{ $t('LEFT_BREAST') }}</h5>

                <div class="flex-row">
                    <label class="fake-label">
                        <input
                            class="custom-input"
                            type="radio"
                            value="YES"
                            @click="showLeftBreastSection = true"
                            name="left-breast"
                            v-model="s3q3Val"
                        />
                        <span class="input-container">{{ $t('YES') }}</span>
                        <span class="checkmark"></span>
                    </label>
                    <label class="fake-label">
                        <input
                            class="custom-input"
                            type="radio"
                            value="NO"
                            @click="leftBreastSection(false)"
                            name="left-breast"
                            v-model="s3q3Val"
                        />
                        <span class="input-container">{{ $t('NO') }}</span>
                        <span class="checkmark"></span>
                    </label>
                </div>

                <left-breast-changes
                    class="mt-3"
                    v-if="showLeftBreastSection"
                    @clicked="leftSelect"
                ></left-breast-changes>
            </div>

            <div class="text-center">
                <div v-if="single">
                    <button @click.stop="cancel()" class="w160 mr-3 app-btn app-btn--small app-btn-default mt-3">
                        {{ $t('CANCEL') }}
                    </button>
                    <button
                        v-if="validateQ2()"
                        @click.stop="save()"
                        class="w160 mr-3 app-btn app-btn--small app-btn-primary mt-3"
                    >
                        {{ $t('SAVE') }}
                    </button>

                    <button v-if="!validateQ2()" class="w160 mr-3 app-btn app-btn--small mt-3" style="opacity: 0.5">
                        {{ $t('SAVE') }}
                    </button>
                </div>

                <div v-else>
                    <button @click.stop="goTo(1)" class="w160 mr-3 app-btn app-btn--small app-btn-default mt-3">
                        {{ $t('PREVIOUS') }}
                    </button>
                    <button
                        v-if="validateQ2()"
                        @click.stop="goTo(3)"
                        class="w160 mr-3 app-btn app-btn--small app-btn-primary mt-3"
                    >
                        {{ $t('NEXT') }}
                    </button>

                    <button v-if="!validateQ2()" class="w160 mr-3 app-btn app-btn--small mt-3" style="opacity: 0.5">
                        {{ $t('NEXT') }}
                    </button>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Steps from './helpers/steps.vue';
import LeftBreastChanges from './helpers/left-breast-changes.vue';
import RightBreastChanges from './helpers/right-breast-changes.vue';

export default {
    mounted() {
        this.s3q2Val = this.$store.getters.survey.section3.q2_1;
        this.s3q3Val = this.$store.getters.survey.section3.q2_2;
        if (this.s3q2Val == 'YES') {
            this.showRightBreastSection = true;
        }
        if (this.s3q3Val == 'YES') {
            this.showLeftBreastSection = true;
        }
    },
    name: 'survey-step3-q2',
    props: {
        s3q2: String,
        single: Boolean,
    },
    data() {
        return {
            s3q2Val: this.s3q2,
            s3q3Val: null,
            showRightBreastSection: false,
            showRightBreastSectionClick: false,
            showLeftBreastSection: false,
            showLeftBreastSectionClick: false,
            leftBreastClick: false,
            rightBreastClick: false,
        };
    },
    computed: {},
    methods: {
        leftBreastSection(x) {
            this.showLeftBreastSection = x;
            this.showLeftBreastSectionClick = true;
            this.leftBreastClick = false;
        },
        rightBreastSection(x) {
            this.showRightBreastSection = x;
            this.showRightBreastSectionClick = true;
            this.rightBreastClick = false;
        },

        leftSelect() {
            this.leftBreastClick = true;
        },

        rightSelect() {
            this.rightBreastClick = true;
        },

        goTo(id) {
            this.$store.commit('STATE_SURVEY', {
                section3: {
                    ...this.$store.getters.survey.section3,
                    active_section: id,
                    q2_1: this.s3q2Val,
                    q2_2: this.s3q3Val,
                },
            });
        },
        cancel() {
            this.$emit('cancel');
        },
        validateQ2() {
            if (!this.s3q2Val || !this.s3q3Val) {
                return false;
            }

            if (
                this.s3q2Val == 'YES' &&
                (!this.$store.getters.survey.section3.q2_1_size ||
                    !this.$store.getters.survey.section3.q2_1_location.x == -9999)
            ) {
                return false;
            }

            if (
                this.s3q3Val == 'YES' &&
                (!this.$store.getters.survey.section3.q2_2_size ||
                    !this.$store.getters.survey.section3.q2_2_location.x == -9999)
            ) {
                return false;
            }

            return true;
        },
        save() {
            this.$store.commit('STATE_SURVEY', {
                section3: {
                    ...this.$store.getters.survey.section3,
                    q2_1: this.s3q2Val,
                    q2_2: this.s3q3Val,
                },
            });
            this.$emit('save');
        },
    },
    components: {
        Steps,
        LeftBreastChanges,
        RightBreastChanges,
    },
};
</script>
<style>
.select-img-container {
    background-size: contain !important;
    border: 1px solid #f1eeea;
    border-radius: 50px;
    display: block;
    margin: 30px auto;
    /*padding:20px;*/
    text-align: center;
    max-width: 375px;
    /*width: 100%;*/
}

.canvas-cursor {
    cursor: url('/src/assets/images/select-cursor.cur'), text;
}

@media (max-width: 768px) {
    .select-img-container {
        background-size: contain !important;
    }
}

.select-img-container.right-breast {
    background: url('/src/assets/images/right-breast-shape.svg') center center no-repeat;
}

.select-img-container.left-breast {
    background: url('/src/assets/images/left-breast-shape.png') center center no-repeat;
}
</style>



// WEBPACK FOOTER //
// survey-step3-q2.vue?3a6bfe42